const LISTING_SEARCH_PRESETS = {
  artists: {
    mode: "filterable-paginated-section",
    crossPageSearch: false,
    clientPaginationSelector: "[data-artists-client-pagination]",
    param: "search",
    legacyParam: "pp-artists-search",
    rootSelector: ".pp-artists-list--{sectionId}",
    inputSelector: "[data-artist-search-input]",
    statusSelector: "[data-artist-search-status]",
    emptySelector: "[data-artist-search-empty]",
    emptyTextSelector: ".pp-artists-list__search-empty-text",
    itemSelector: "[data-artist-card]",
    cardSelector: "[data-artist-card]",
    gridSelector: "[data-artist-list-grid]",
    resultNameSingular: "artist",
    resultNamePlural: "artists",
    statusTemplate: '{visible} of {total} artists match "{query}".',
    loadingText: "Searching artists.",
    emptyTextTemplate: 'No artists match "{query}". Try another keyword.',
    pendingClass: "pp-artists-clean-page-pending-{sectionId}",
  },
  "guided-tour": {
    mode: "filterable-paginated-section",
    param: "search",
    legacyParam: "pp-guided-tour-search",
    rootSelector: ".pp-guided-tour-list--{sectionId}",
    inputSelector: "[data-guided-tour-search-input]",
    statusSelector: "[data-guided-tour-search-status]",
    emptySelector: "[data-guided-tour-search-empty]",
    emptyTextSelector: ".pp-guided-tour-list__search-empty-text",
    itemSelector: "[data-guided-tour-card]",
    cardSelector: "[data-guided-tour-card]",
    gridSelector: "[data-guided-tour-list-grid]",
    paginationSelector: ".pp-guided-tour-list__pagination",
    resultNameSingular: "guided tour",
    resultNamePlural: "guided tours",
    statusTemplate: '{visible} of {total} guided tours match "{query}".',
    loadingText: "Searching guided tours.",
    emptyTextTemplate: 'No guided tours match "{query}". Try another keyword.',
    pendingClass: "pp-guided-tour-search-pending-{sectionId}",
    filters: [
      {
        name: "status",
        selector: "[data-filter]",
        paramName: "pp-guided-tour-status",
        valueDataset: "filter",
        cardDataset: "status",
        matchType: "exact",
        interactiveSelector: "a[data-filter]",
        togglesOnRepeat: false,
      },
    ],
  },
  exhibitions: {
    mode: "filterable-paginated-section",
    crossPageSearch: false,
    clientPaginationSelector: "[data-exhibitions-client-pagination]",
    param: "search",
    legacyParam: "pp-exhibitions-search",
    rootSelector: ".pp-exhibitions-list--{sectionId}",
    inputSelector: "[data-exhibitions-search-input]",
    statusSelector: "[data-exhibitions-search-status]",
    emptySelector: "[data-exhibitions-search-empty]",
    emptyTextSelector: ".pp-listing-card__search-empty-text",
    itemSelector: "[data-filter-item]",
    cardSelector: "[data-filter-item]",
    gridSelector: "[data-exhibitions-list-grid]",
    resultNameSingular: "exhibition",
    resultNamePlural: "exhibitions",
    statusTemplate: '{visible} of {total} exhibitions match "{query}".',
    loadingText: "Searching exhibitions.",
    emptyTextTemplate: 'No exhibitions match "{query}". Try another keyword.',
    pendingClass: "pp-exhibitions-clean-page-pending-{sectionId}",
    filters: [
      {
        name: "status",
        selector: "[data-filter]",
        paramName: "pp-exhibition-status",
        valueDataset: "filter",
        cardDataset: "status",
        matchType: "exact",
        interactiveSelector: "a[data-filter]",
        togglesOnRepeat: false,
      },
      {
        name: "artist",
        selector: "[data-artist-filter]",
        paramName: "pp-exhibition-artist",
        valueDataset: "artistFilter",
        cardDataset: "artistHandles",
        matchType: "tokens",
        labelSelector: "[data-artist-filter-current]",
        detailsSelector: "[data-artist-filter-details]",
        interactiveSelector: "button[data-artist-filter]",
        clearOnSearch: true,
        togglesOnRepeat: true,
      },
      {
        name: "year",
        selector: "[data-year-filter]",
        paramName: "pp-exhibition-year",
        valueDataset: "yearFilter",
        cardDataset: "year",
        matchType: "exact",
        labelSelector: "[data-year-filter-current]",
        detailsSelector: "[data-year-filter-details]",
        interactiveSelector: "button[data-year-filter]",
        togglesOnRepeat: true,
      },
    ],
  },
  editionen: {
    mode: "filterable-paginated-section",
    crossPageSearch: false,
    clientPaginationSelector: "[data-editionen-client-pagination]",
    param: "search",
    legacyParam: "pp-editionen-search",
    rootSelector: ".pp-editionen-list--{sectionId}",
    inputSelector: "[data-editionen-search-input]",
    statusSelector: "[data-editionen-search-status]",
    emptySelector: "[data-editionen-search-empty]",
    emptyTextSelector: ".pp-listing-card__search-empty-text",
    itemSelector: "[data-editionen-card]",
    cardSelector: "[data-editionen-card]",
    gridSelector: "[data-editionen-list-grid]",
    paginationSelector: "[data-editionen-pagination]",
    resultNameSingular: "edition",
    resultNamePlural: "editions",
    statusTemplate: '{visible} of {total} editions match "{query}".',
    loadingText: "Searching editions.",
    emptyTextTemplate: 'No editions match "{query}". Try another keyword.',
    pendingClass: "pp-editionen-clean-page-pending-{sectionId}",
    filters: [
      {
        name: "artist",
        selector: "[data-artist-filter]",
        paramName: "pp-editionen-artist",
        valueDataset: "artistFilter",
        cardDataset: "artistHandles",
        matchType: "tokens",
        labelSelector: "[data-artist-filter-current]",
        detailsSelector: "[data-artist-filter-details]",
        interactiveSelector: "button[data-artist-filter]",
        clearOnSearch: true,
        togglesOnRepeat: true,
      },
      {
        name: "year",
        selector: "[data-year-filter]",
        paramName: "pp-editionen-year",
        valueDataset: "yearFilter",
        cardDataset: "year",
        matchType: "exact",
        interactiveSelector: "button[data-year-filter]",
        togglesOnRepeat: true,
      },
    ],
  },
  "pretty-wall": {
    mode: "filterable-paginated-section",
    param: "search",
    legacyParam: "pp-pretty-wall-search",
    rootSelector: ".pp-pretty-wall-list--{sectionId}",
    inputSelector: "[data-pretty-wall-search-input]",
    statusSelector: "[data-pretty-wall-search-status]",
    emptySelector: "[data-pretty-wall-search-empty]",
    emptyTextSelector: ".pp-listing-card__search-empty-text",
    itemSelector: "[data-pretty-wall-card]",
    cardSelector: "[data-pretty-wall-card]",
    gridSelector: "[data-pretty-wall-list-items]",
    paginationSelector: "[data-pretty-wall-pagination]",
    resultNameSingular: "project",
    resultNamePlural: "projects",
    statusTemplate: '{visible} of {total} projects match "{query}".',
    loadingText: "Searching projects.",
    emptyTextTemplate: 'No projects match "{query}". Try another keyword.',
    pendingClass: "pp-pretty-wall-clean-page-pending-{sectionId}",
    filters: [
      {
        name: "artist",
        selector: "[data-artist-filter]",
        paramName: "pp-pretty-wall-artist",
        valueDataset: "artistFilter",
        cardDataset: "artistHandles",
        matchType: "tokens",
        labelSelector: "[data-artist-filter-current]",
        detailsSelector: "[data-artist-filter-details]",
        interactiveSelector: "button[data-artist-filter]",
        clearOnSearch: true,
        togglesOnRepeat: true,
      },
    ],
  },
};

class PrettyPortalListingSearch {
  constructor(root) {
    this.root = root;
    this.presetName = root.dataset.ppListingSearchPreset || "";
    this.preset = LISTING_SEARCH_PRESETS[this.presetName] || {};
    this.sectionId = root.dataset.ppListingSearchSectionId || "";
    this.mode = this.getOption("mode", "local");
    this.maxSearchLength = Number.parseInt(
      this.getOption("maxLength", "120"),
      10,
    );
    this.debounceDelay = Number.parseInt(this.getOption("debounce", "500"), 10);
    this.searchParamName = this.getOption("param", "pp-listing-search");
    this.legacySearchParamName = this.getOption("legacyParam", "");
    this.input = root.querySelector(
      this.getOption("inputSelector", "[data-pp-listing-search-input]"),
    );
    this.status = root.querySelector(
      this.getOption("statusSelector", "[data-pp-listing-search-status]"),
    );
    this.emptyState = this.queryOptional(
      this.getOption("emptySelector", "[data-pp-listing-search-empty]"),
    );
    this.emptyText = this.queryOptional(
      this.getOption("emptyTextSelector", ""),
    );
    this.pagination = this.queryOptional(
      this.getOption("paginationSelector", ""),
    );
    this.itemSelector = this.getOption("itemSelector", "[data-search-item]");
    this.cardSelector = this.getOption("cardSelector", this.itemSelector);
    this.items = Array.from(root.querySelectorAll(this.itemSelector));
    this.resultNameSingular = this.getOption("resultNameSingular", "item");
    this.resultNamePlural = this.getOption("resultNamePlural", "items");
    this.statusTemplate = this.getOption("statusTemplate", "");
    this.loadingText = this.getOption("loadingText", "");
    this.emptyTextTemplate = this.getOption("emptyTextTemplate", "");
    // Translated strings are rendered by Liquid into data-pp-listing-search-*
    // attributes; the English values below are only fallbacks.
    this.filterStatusTemplate = this.getOption(
      "filterStatusTemplate",
      `{visible} of {total} ${this.resultNamePlural} match the selected filters.`,
    );
    this.filterEmptyText = this.getOption(
      "filterEmptyText",
      `No ${this.resultNamePlural} match the selected filters. Try another filter.`,
    );
    this.previousPageLabel = this.getOption("previousPageLabel", "Previous page");
    this.nextPageLabel = this.getOption("nextPageLabel", "Next page");
    this.pageLabelTemplate = this.getOption("pageLabelTemplate", "Page {page}");
    this.grid = this.queryOptional(this.getOption("gridSelector", ""));
    this.rootSelector = this.getOption("rootSelector", "");
    this.pendingClass = this.getOption("pendingClass", "");
    this.searchFetchConcurrency = Number.parseInt(
      this.getOption("fetchConcurrency", "3"),
      10,
    );
    this.filterConfigs = this.getFilterConfigs();
    this.pageCache = new Map();
    this.searchTimeout = 0;
    this.searchRequestId = 0;
    this.clientPagination = this.queryOptional(
      this.getOption("clientPaginationSelector", ""),
    );
    this.clientItemsPerPage =
      Number.parseInt(this.getOption("itemsPerPage", "0"), 10) || 0;
    // Load-more mode: show `itemsPerPage` cards, then reveal that many more per
    // click (no page numbers, no URL changes).
    this.clientLoadMore = this.getOption("loadMore", "") === "true";
    this.loadMoreLabel = this.getOption("loadMoreLabel", "Show more");
    this.clientPage = this.getInitialClientPage();
    this.abortController = new AbortController();
    this.boundClickHandler = (event) => this.handleRootClick(event);
    this.boundOutsideClickHandler = (event) =>
      this.closeOpenDetailsOnOutsideClick(event);
    this.boundPopStateHandler = (event) => this.handlePopState(event);
  }

  queryOptional(selector) {
    return selector ? this.root.querySelector(selector) : null;
  }

  getOption(name, fallback = "") {
    const datasetKey = `ppListingSearch${name.charAt(0).toUpperCase()}${name.slice(1)}`;
    const value =
      this.root.dataset[datasetKey] ?? this.preset[name] ?? fallback;

    return typeof value === "string"
      ? value.replaceAll("{sectionId}", this.sectionId)
      : value;
  }

  init() {
    if (!this.items.length) return;

    if (this.mode === "filterable-paginated-section") {
      this.root.addEventListener("click", this.boundClickHandler, {
        signal: this.abortController.signal,
      });
      document.addEventListener("click", this.boundOutsideClickHandler, {
        signal: this.abortController.signal,
      });
      if (this.clientItemsPerPage > 0) {
        window.addEventListener("popstate", this.boundPopStateHandler, {
          signal: this.abortController.signal,
        });
      }
      if (this.input instanceof HTMLInputElement) {
        this.bindSearchInput();
      }
      this.hydrateFilterableSearchFromUrl();

      const initialFilters = this.getInitialFilterValues();
      const hasInitialState =
        Boolean(this.getNormalizedSearchQuery()) ||
        this.hasActiveFilter(initialFilters);
      const keepPendingUntilListState =
        this.root.ownerDocument.documentElement.classList.contains(
          this.pendingClass,
        ) && hasInitialState;
      const didStartCleanPageSync = this.syncCleanInitialPage(
        keepPendingUntilListState,
      );

      if (!didStartCleanPageSync) {
        this.applyFilterableListState(initialFilters, {
          resetClientPage: false,
        }).finally(() => this.clearPendingClass());
      }

      return;
    }

    if (this.mode === "paginated-section") {
      this.root.addEventListener("click", this.boundClickHandler, {
        signal: this.abortController.signal,
      });
      let initialQuery = "";
      if (this.input instanceof HTMLInputElement) {
        this.bindSearchInput();
        initialQuery = this.getNormalizedSearchQuery();
      }
      const didStartCleanPageSync = this.syncCleanInitialPage(
        Boolean(initialQuery),
      );
      if (!didStartCleanPageSync && this.input instanceof HTMLInputElement) {
        this.applyPaginatedSearch({ syncUrl: false }).finally(() =>
          this.clearPendingClass(),
        );
      }
      return;
    }

    if (!(this.input instanceof HTMLInputElement)) return;
    this.bindSearchInput();
    this.applySearch();
    this.clearPendingClass();
  }

  destroy() {
    window.clearTimeout(this.searchTimeout);
    this.abortController.abort();
  }

  bindSearchInput() {
    const initialQuery = this.getQueryFromUrl();
    if (initialQuery) {
      this.input.value = initialQuery;
    }

    this.input.addEventListener("input", () => this.scheduleSearch(), {
      signal: this.abortController.signal,
    });
    this.input.addEventListener(
      "search",
      () => {
        if (this.mode === "filterable-paginated-section") {
          const filters = this.applySearchDrivenFilterRules(
            this.getActiveFilterValues(),
          );
          this.applyFilterableListState(filters);
          this.updateFilterableUrl(filters);
          return;
        }

        if (this.mode === "paginated-section") {
          this.applyPaginatedSearch();
          return;
        }

        this.applySearch();
      },
      { signal: this.abortController.signal },
    );
  }

  normalizeSearchValue(value) {
    return String(value || "")
      .replace(/[\u0000-\u001f\u007f]/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, this.maxSearchLength);
  }

  limitSearchInputValue(value) {
    return String(value || "").slice(0, this.maxSearchLength);
  }

  normalizePageNumber(value) {
    const pageNumber = Number.parseInt(value, 10);
    return Number.isFinite(pageNumber) && pageNumber > 0 ? pageNumber : 1;
  }

  getQueryFromUrl() {
    const url = new URL(window.location.href);
    return this.normalizeSearchValue(
      url.searchParams.get(this.searchParamName) ||
        url.searchParams.get(this.legacySearchParamName),
    );
  }

  removePaginationParams(url) {
    Array.from(url.searchParams.keys()).forEach((key) => {
      if (key === "page" || key.startsWith("page_")) {
        url.searchParams.delete(key);
      }
    });
  }

  updateUrl(query) {
    const url = new URL(window.location.href);
    if (this.mode === "paginated-section") {
      this.removePaginationParams(url);
    }

    if (query) {
      url.searchParams.set(this.searchParamName, query);
      this.removePaginationParams(url);
    } else {
      url.searchParams.delete(this.searchParamName);
    }

    if (
      this.legacySearchParamName &&
      this.legacySearchParamName !== this.searchParamName
    ) {
      url.searchParams.delete(this.legacySearchParamName);
    }

    window.history.replaceState({}, "", url.toString());
  }

  formatTemplate(template, replacements) {
    return Object.entries(replacements).reduce(
      (result, [key, value]) => result.replaceAll(`{${key}}`, String(value)),
      template,
    );
  }

  updateStatus(visibleCount, query, totalCount = this.items.length) {
    if (!(this.status instanceof HTMLElement)) return;

    if (!query) {
      this.status.textContent = "";
      return;
    }

    if (this.statusTemplate) {
      this.status.textContent = this.formatTemplate(this.statusTemplate, {
        visible: visibleCount,
        total: totalCount,
        query,
      });
      return;
    }

    const resultName =
      visibleCount === 1 ? this.resultNameSingular : this.resultNamePlural;
    this.status.textContent = `${visibleCount} ${resultName} found.`;
  }

  updateLoadingStatus() {
    if (this.status instanceof HTMLElement && this.loadingText) {
      this.status.textContent = this.loadingText;
      return;
    }

    if (this.status instanceof HTMLElement) {
      this.status.textContent = `Searching ${this.resultNamePlural}.`;
    }
  }

  updateEmptyState(visibleCount, query) {
    if (!(this.emptyState instanceof HTMLElement)) return;

    const hasQuery = Boolean(query);
    const hasResults = visibleCount > 0;
    this.emptyState.hidden = !hasQuery || hasResults;

    if (
      hasQuery &&
      !hasResults &&
      this.emptyText instanceof HTMLElement &&
      this.emptyTextTemplate
    ) {
      this.emptyText.textContent = this.formatTemplate(this.emptyTextTemplate, {
        query,
      });
    }
  }

  updateFilterableEmptyState(visibleCount, query, activeFilters) {
    if (!(this.emptyState instanceof HTMLElement)) return;

    const hasQuery = Boolean(query);
    const hasActiveFilter = this.hasActiveFilter(activeFilters);
    const hasResults = visibleCount > 0;
    this.emptyState.hidden = (!hasQuery && !hasActiveFilter) || hasResults;

    if (!(this.emptyText instanceof HTMLElement) || hasResults) return;

    if (hasQuery) {
      if (this.emptyTextTemplate) {
        this.emptyText.textContent = this.formatTemplate(
          this.emptyTextTemplate,
          { query },
        );
      } else {
        this.emptyText.textContent = `No ${this.resultNamePlural} match "${query}". Try another keyword.`;
      }
      return;
    }

    this.emptyText.textContent = this.filterEmptyText;
  }

  applySearch() {
    const limitedInputValue = this.limitSearchInputValue(this.input.value);
    if (this.input.value !== limitedInputValue) {
      this.input.value = limitedInputValue;
    }

    const query = this.normalizeSearchValue(limitedInputValue);
    const normalizedQuery = query.toLowerCase();
    let visibleCount = 0;

    this.items.forEach((item) => {
      const haystack = String(item.dataset.searchText || "").toLowerCase();
      const isVisible = !normalizedQuery || haystack.includes(normalizedQuery);
      item.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    this.root.classList.toggle("is-searching", Boolean(query));

    if (this.pagination instanceof HTMLElement) {
      this.pagination.hidden = Boolean(query);
    }

    this.updateStatus(visibleCount, query);
    this.updateEmptyState(visibleCount, query);
    this.updateUrl(query);
  }

  getFilterConfigs() {
    if (Array.isArray(this.preset.filters)) {
      return this.preset.filters.map((filterConfig) => ({ ...filterConfig }));
    }

    const configs = [];

    if (this.root.dataset.ppListingSearchStatusFilterSelector) {
      configs.push({
        name: "status",
        selector: this.root.dataset.ppListingSearchStatusFilterSelector,
        paramName:
          this.root.dataset.ppListingSearchStatusFilterParam ||
          "pp-listing-status",
        valueDataset:
          this.root.dataset.ppListingSearchStatusFilterValueDataset || "filter",
        cardDataset:
          this.root.dataset.ppListingSearchStatusFilterCardDataset || "status",
        matchType: "exact",
        interactiveSelector:
          this.root.dataset.ppListingSearchStatusFilterInteractiveSelector ||
          "a[data-filter]",
        togglesOnRepeat: false,
      });
    }

    if (this.root.dataset.ppListingSearchArtistFilterSelector) {
      configs.push({
        name: "artist",
        selector: this.root.dataset.ppListingSearchArtistFilterSelector,
        paramName:
          this.root.dataset.ppListingSearchArtistFilterParam ||
          "pp-listing-artist",
        valueDataset:
          this.root.dataset.ppListingSearchArtistFilterValueDataset ||
          "artistFilter",
        cardDataset:
          this.root.dataset.ppListingSearchArtistFilterCardDataset ||
          "artistHandles",
        matchType: "tokens",
        labelSelector:
          this.root.dataset.ppListingSearchArtistFilterLabelSelector ||
          "[data-artist-filter-current]",
        detailsSelector:
          this.root.dataset.ppListingSearchArtistFilterDetailsSelector ||
          "[data-artist-filter-details]",
        interactiveSelector:
          this.root.dataset.ppListingSearchArtistFilterInteractiveSelector ||
          "button[data-artist-filter]",
        clearOnSearch: true,
        togglesOnRepeat: true,
      });
    }

    if (this.root.dataset.ppListingSearchYearFilterSelector) {
      configs.push({
        name: "year",
        selector: this.root.dataset.ppListingSearchYearFilterSelector,
        paramName:
          this.root.dataset.ppListingSearchYearFilterParam || "pp-listing-year",
        valueDataset:
          this.root.dataset.ppListingSearchYearFilterValueDataset ||
          "yearFilter",
        cardDataset:
          this.root.dataset.ppListingSearchYearFilterCardDataset || "year",
        matchType: "exact",
        interactiveSelector:
          this.root.dataset.ppListingSearchYearFilterInteractiveSelector ||
          "button[data-year-filter]",
        togglesOnRepeat: true,
      });
    }

    return configs;
  }

  getFilterOptions(config) {
    return Array.from(this.root.querySelectorAll(config.selector));
  }

  getFilterValue(option, config) {
    return (
      String(option?.dataset?.[config.valueDataset] || "all").trim() || "all"
    );
  }

  normalizeFilterValue(value, config) {
    const resolvedValue = String(value || "all").trim();
    if (resolvedValue === "all") return "all";

    return this.getFilterOptions(config).some(
      (option) => this.getFilterValue(option, config) === resolvedValue,
    )
      ? resolvedValue
      : "all";
  }

  getInitialFilterValue(config) {
    const url = new URL(window.location.href);
    return this.normalizeFilterValue(
      url.searchParams.get(config.paramName) || "all",
      config,
    );
  }

  getInitialFilterValues() {
    return this.filterConfigs.reduce((filters, config) => {
      filters[config.name] = this.getInitialFilterValue(config);
      return filters;
    }, {});
  }

  getActiveFilterValue(config) {
    const activeOption = this.root.querySelector(
      `${config.selector}.is-active`,
    );
    return this.normalizeFilterValue(
      this.getFilterValue(activeOption, config) ||
        this.getInitialFilterValue(config),
      config,
    );
  }

  getActiveFilterValues() {
    return this.filterConfigs.reduce((filters, config) => {
      filters[config.name] = this.getActiveFilterValue(config);
      return filters;
    }, {});
  }

  hasActiveFilter(filters = this.getActiveFilterValues()) {
    return this.filterConfigs.some((config) => filters[config.name] !== "all");
  }

  getFilterDisplayLabel(config, value) {
    const resolvedValue = this.normalizeFilterValue(value, config);
    if (resolvedValue === "all") return "";

    const option = this.getFilterOptions(config).find(
      (filterOption) =>
        this.getFilterValue(filterOption, config) === resolvedValue,
    );
    if (!option) return "";

    const labelDataset = `${config.valueDataset}Label`;
    return (
      option.dataset[labelDataset] ||
      option.textContent.replace(/\s+/g, " ").trim() ||
      resolvedValue
    );
  }

  updateFilterState(config, value) {
    const resolvedValue = this.normalizeFilterValue(value, config);
    let currentLabel = "";
    const label = config.labelSelector
      ? this.root.querySelector(config.labelSelector)
      : null;
    const defaultLabel = label?.dataset.defaultLabel || "";

    this.getFilterOptions(config).forEach((option) => {
      const isActive = this.getFilterValue(option, config) === resolvedValue;
      option.classList.toggle("is-active", isActive);

      if (option instanceof HTMLButtonElement) {
        option.setAttribute("aria-pressed", isActive ? "true" : "false");
      } else if (option instanceof HTMLAnchorElement) {
        option.setAttribute("aria-current", isActive ? "page" : "false");
      }

      if (isActive && resolvedValue !== "all") {
        const labelDataset = `${config.valueDataset}Label`;
        currentLabel =
          option.dataset[labelDataset] ||
          option.textContent.replace(/\s+/g, " ").trim() ||
          defaultLabel;
      }
    });

    if (label instanceof HTMLElement) {
      label.textContent = currentLabel || defaultLabel;
    }
  }

  updateAllFilterStates(filters) {
    this.filterConfigs.forEach((config) => {
      this.updateFilterState(config, filters[config.name] || "all");
    });
  }

  getNormalizedSearchQuery() {
    if (!(this.input instanceof HTMLInputElement)) return "";

    const limitedInputValue = this.limitSearchInputValue(this.input.value);
    if (this.input.value !== limitedInputValue) {
      this.input.value = limitedInputValue;
    }

    return this.normalizeSearchValue(limitedInputValue).toLowerCase();
  }

  getDisplaySearchQuery() {
    if (!(this.input instanceof HTMLInputElement)) return "";
    return this.normalizeSearchValue(this.input.value);
  }

  hydrateFilterableSearchFromUrl() {
    if (!(this.input instanceof HTMLInputElement)) return;

    const query = this.getQueryFromUrl();
    if (this.input.value !== query) {
      this.input.value = query;
    }
  }

  matchesCardFilter(card, config, value) {
    if (value === "all") return true;

    const cardValue = String(card.dataset[config.cardDataset] || "");
    if (config.matchType === "tokens") {
      return cardValue.split(/\s+/).filter(Boolean).includes(value);
    }

    return cardValue === value;
  }

  getFilterableMatchingCards(cards, filters, query) {
    return cards.filter((card) => {
      const matchesFilters = this.filterConfigs.every((config) =>
        this.matchesCardFilter(card, config, filters[config.name] || "all"),
      );
      const haystack =
        `${card.dataset.searchText || ""} ${card.textContent || ""}`.toLowerCase();
      const matchesSearch = !query || haystack.includes(query);

      return matchesFilters && matchesSearch;
    });
  }

  applySearchDrivenFilterRules(filters) {
    const query = this.getNormalizedSearchQuery();
    if (!query) return filters;

    return this.filterConfigs.reduce(
      (nextFilters, config) => {
        if (config.clearOnSearch && nextFilters[config.name] !== "all") {
          nextFilters[config.name] = "all";
        }
        return nextFilters;
      },
      { ...filters },
    );
  }

  updateFilterableStatus(visibleCount, totalCount, query, filters) {
    if (!(this.status instanceof HTMLElement)) return;

    if (query) {
      if (this.statusTemplate) {
        this.status.textContent = this.formatTemplate(this.statusTemplate, {
          visible: visibleCount,
          total: totalCount,
          query,
        });
      } else {
        this.status.textContent = `${visibleCount} of ${totalCount} ${this.resultNamePlural} match "${query}".`;
      }
      return;
    }

    if (this.hasActiveFilter(filters)) {
      this.status.textContent = this.formatTemplate(this.filterStatusTemplate, {
        visible: visibleCount,
        total: totalCount,
      });
      return;
    }

    this.status.textContent = "";
  }

  updateActiveFilterRemoveButtons(filters = this.getActiveFilterValues()) {
    const removeContainers = Array.from(
      this.root.querySelectorAll("[data-filter-remove-container]"),
    );
    const removeLists = Array.from(
      this.root.querySelectorAll("[data-filter-remove-list]"),
    );
    if (!removeContainers.length || !removeLists.length) return;

    const activeFilters = this.filterConfigs
      .map((config) => {
        const value = this.normalizeFilterValue(
          filters[config.name] || "all",
          config,
        );
        return {
          config,
          value,
          label: this.getFilterDisplayLabel(config, value),
        };
      })
      .filter((filter) => filter.value !== "all" && filter.label);
    const hasActiveState =
      activeFilters.length > 0 || Boolean(this.getDisplaySearchQuery());

    removeContainers.forEach((container) => {
      if (container.hasAttribute("data-filter-remove-always-visible")) {
        container.hidden = false;
        return;
      }

      container.hidden = !hasActiveState;
    });

    removeLists.forEach((list) => {
      list.replaceChildren();

      const removeLabel = this.root.dataset.filterRemoveLabel || "Remove";

      activeFilters.forEach((filter) => {
        const pill = document.createElement("button");
        pill.type = "button";
        pill.className =
          "pills__pill pills__pill--desktop-small facets-remove__pill pp-exhibitions-list__remove-pill";
        pill.dataset.filterRemove = filter.config.name;
        pill.textContent = filter.label;

        const icon = document.createElement("span");
        icon.className = "svg-wrapper svg-wrapper--smaller";
        icon.setAttribute("aria-hidden", "true");
        icon.textContent = "×";
        pill.append(" ", icon);

        const hiddenText = document.createElement("span");
        hiddenText.className = "visually-hidden";
        hiddenText.textContent = removeLabel;
        pill.append(hiddenText);

        list.append(pill);
      });
    });
  }

  updateResetButtonState(
    filters = this.getActiveFilterValues(),
    query = this.getDisplaySearchQuery(),
  ) {
    const resetButtons = Array.from(
      this.root.querySelectorAll("[data-filter-reset]"),
    );
    if (!resetButtons.length) return;

    const hasActiveState = Boolean(query) || this.hasActiveFilter(filters);
    resetButtons.forEach((button) => {
      if (
        button.dataset.filterResetAlwaysVisible === "true" ||
        button.hasAttribute("data-filter-reset-always-visible")
      ) {
        button.hidden = false;
        return;
      }

      button.hidden = !hasActiveState;
    });
  }

  updateFilterableUrl(filters = this.getActiveFilterValues()) {
    const url = new URL(window.location.href);
    const currentPage = this.getCurrentPage();
    const searchQuery = this.getDisplaySearchQuery();
    this.removePaginationParams(url);

    if (!searchQuery && currentPage > 1) {
      url.searchParams.set("page", String(currentPage));
    }

    this.filterConfigs.forEach((config) => {
      const resolvedValue = this.normalizeFilterValue(
        filters[config.name] || "all",
        config,
      );
      if (resolvedValue === "all") {
        url.searchParams.delete(config.paramName);
      } else {
        url.searchParams.set(config.paramName, resolvedValue);
      }
    });

    if (searchQuery) {
      url.searchParams.set(this.searchParamName, searchQuery);
    } else {
      url.searchParams.delete(this.searchParamName);
    }

    if (
      this.legacySearchParamName &&
      this.legacySearchParamName !== this.searchParamName
    ) {
      url.searchParams.delete(this.legacySearchParamName);
    }

    window.history.replaceState({}, "", url.toString());
  }

  async applyFilterableListState(
    filters = this.getActiveFilterValues(),
    { resetClientPage = true } = {},
  ) {
    if (resetClientPage) {
      this.clientPage = 1;
    }

    const resolvedFilters = this.filterConfigs.reduce((nextFilters, config) => {
      nextFilters[config.name] = this.normalizeFilterValue(
        filters[config.name] || "all",
        config,
      );
      return nextFilters;
    }, {});
    const query = this.getNormalizedSearchQuery();
    const shouldSearchAcrossPages =
      this.getOption("crossPageSearch", true) &&
      (Boolean(query) || this.hasActiveFilter(resolvedFilters));

    this.updateAllFilterStates(resolvedFilters);
    this.updateActiveFilterRemoveButtons(resolvedFilters);
    this.updateResetButtonState(resolvedFilters, query);

    if (shouldSearchAcrossPages) {
      const requestId = this.searchRequestId + 1;
      this.searchRequestId = requestId;
      this.root.classList.add("is-searching", "is-search-loading");
      this.root.setAttribute("aria-busy", "true");
      this.updateLoadingStatus();

      const allCards = await this.getAllSearchCards();
      if (requestId !== this.searchRequestId) return;

      const matchingCards = this.getFilterableMatchingCards(
        allCards,
        resolvedFilters,
        query,
      );
      this.renderCards(matchingCards);
      this.root.classList.remove("is-search-loading");
      this.root.removeAttribute("aria-busy");
      this.updateFilterableStatus(
        matchingCards.length,
        allCards.length,
        query,
        resolvedFilters,
      );
      this.updateFilterableEmptyState(
        matchingCards.length,
        query,
        resolvedFilters,
      );
      return;
    }

    this.searchRequestId += 1;
    this.root.classList.remove("is-searching", "is-search-loading");
    this.root.removeAttribute("aria-busy");
    this.restoreCurrentPageCards();

    const cards = this.getCards();
    const matchingCards = this.getFilterableMatchingCards(
      cards,
      resolvedFilters,
      query,
    );
    const visibleCards = this.applyClientPagination(matchingCards);
    cards.forEach((card) => {
      card.hidden = !visibleCards.includes(card);
      card.style.borderBottomStyle = "";
    });
    // `:last-child` only removes the divider from the true last DOM node, but
    // hidden cards past the current page stay in the DOM, so the actually
    // visible last card keeps its border unless we clear it explicitly here.
    if (visibleCards.length) {
      visibleCards[visibleCards.length - 1].style.borderBottomStyle = "none";
    }

    this.updateFilterableStatus(
      matchingCards.length,
      cards.length,
      query,
      resolvedFilters,
    );
    this.updateFilterableEmptyState(
      matchingCards.length,
      query,
      resolvedFilters,
    );
  }

  getInitialClientPage() {
    if (this.clientItemsPerPage <= 0 || this.clientLoadMore) return 1;
    const url = new URL(window.location.href);
    return this.normalizePageNumber(url.searchParams.get("page") || "1");
  }

  updateClientPageUrl(pageNumber, historyMethod = "pushState") {
    const url = new URL(window.location.href);
    if (pageNumber > 1) {
      url.searchParams.set("page", String(pageNumber));
    } else {
      url.searchParams.delete("page");
    }
    window.history[historyMethod]({}, "", url.toString());
  }

  handlePopState() {
    if (this.clientItemsPerPage <= 0 || this.clientLoadMore) return;

    const url = new URL(window.location.href);
    const pageNumber = this.normalizePageNumber(
      url.searchParams.get("page") || "1",
    );
    if (pageNumber === this.clientPage) return;

    this.clientPage = pageNumber;
    this.applyFilterableListState(this.getActiveFilterValues(), {
      resetClientPage: false,
    });
  }

  applyClientPagination(matchingCards) {
    if (
      this.clientItemsPerPage <= 0 ||
      !(this.clientPagination instanceof HTMLElement)
    ) {
      return matchingCards;
    }

    const totalPages = Math.max(
      1,
      Math.ceil(matchingCards.length / this.clientItemsPerPage),
    );

    if (this.clientLoadMore) {
      if (this.clientPage > totalPages) this.clientPage = totalPages;
      if (this.clientPage < 1) this.clientPage = 1;
      this.renderClientLoadMore(this.clientPage < totalPages);
      return matchingCards.slice(0, this.clientPage * this.clientItemsPerPage);
    }

    if (this.clientPage > totalPages) this.clientPage = totalPages;
    if (this.clientPage < 1) this.clientPage = 1;

    if (totalPages <= 1) {
      this.clientPagination.hidden = true;
      this.clientPagination.replaceChildren();
    } else {
      this.clientPagination.hidden = false;
      this.renderClientPaginationNav(totalPages);
    }

    const start = (this.clientPage - 1) * this.clientItemsPerPage;
    return matchingCards.slice(start, start + this.clientItemsPerPage);
  }

  buildPaginationParts(currentPage, totalPages, windowSize = 2) {
    const parts = [];

    for (let page = 1; page <= totalPages; page += 1) {
      const isBoundary = page === 1 || page === totalPages;
      const isWithinWindow =
        page >= currentPage - windowSize && page <= currentPage + windowSize;

      if (isBoundary || isWithinWindow) {
        parts.push({ type: "page", page });
      } else if (parts[parts.length - 1]?.type !== "gap") {
        parts.push({ type: "gap" });
      }
    }

    return parts;
  }

  // Cards are re-cloned on every list update, so new cards are found by their
  // position among the visible cards rather than by node identity.
  animateRevealedCards(previousVisibleCount) {
    const revealedCards = this.getCards()
      .filter((card) => !card.hidden)
      .slice(previousVisibleCount);

    revealedCards.forEach((card, index) => {
      card.style.setProperty("--pp-load-more-delay", `${index * 60}ms`);
      card.classList.add("pp-load-more-enter");
      card.addEventListener(
        "animationend",
        () => {
          card.classList.remove("pp-load-more-enter");
          card.style.removeProperty("--pp-load-more-delay");
        },
        { once: true },
      );
    });
  }

  renderClientLoadMore(hasMore) {
    this.clientPagination.hidden = !hasMore;
    if (!hasMore) {
      this.clientPagination.replaceChildren();
      return;
    }
    if (this.clientPagination.querySelector("[data-client-load-more]")) return;

    const button = document.createElement("button");
    button.type = "button";
    button.className = "pp-button pp-button--secondary";
    button.dataset.clientLoadMore = "";
    button.textContent = this.loadMoreLabel;
    this.clientPagination.replaceChildren(button);
  }

  renderClientPaginationNav(totalPages) {
    const list = document.createElement("ol");
    list.className = "pp-listing-card__pagination-list";
    list.setAttribute("role", "list");

    const makeArrow = (label, targetPage, enabled) => {
      const item = document.createElement("li");
      item.className = "pp-listing-card__pagination-item";

      if (enabled) {
        const link = document.createElement("a");
        link.href = "#";
        link.className =
          "pp-listing-card__pagination-link pp-listing-card__pagination-arrow";
        link.dataset.clientPageLink = "";
        link.dataset.pageNumber = String(targetPage);
        link.setAttribute(
          "aria-label",
          label === "prev" ? this.previousPageLabel : this.nextPageLabel,
        );
        link.textContent = label === "prev" ? "←" : "→";
        item.append(link);
      } else {
        const span = document.createElement("span");
        span.className =
          "pp-listing-card__pagination-link pp-listing-card__pagination-arrow is-disabled";
        span.setAttribute("aria-disabled", "true");
        span.textContent = label === "prev" ? "←" : "→";
        item.append(span);
      }

      return item;
    };

    list.append(makeArrow("prev", this.clientPage - 1, this.clientPage > 1));

    this.buildPaginationParts(this.clientPage, totalPages).forEach((part) => {
      const item = document.createElement("li");
      item.className = "pp-listing-card__pagination-item";

      if (part.type === "gap") {
        const span = document.createElement("span");
        span.className = "pp-listing-card__pagination-gap";
        span.setAttribute("aria-hidden", "true");
        span.textContent = "…";
        item.append(span);
      } else if (part.page === this.clientPage) {
        const span = document.createElement("span");
        span.className = "pp-listing-card__pagination-link is-current";
        span.setAttribute("aria-current", "page");
        span.textContent = String(part.page);
        item.append(span);
      } else {
        const link = document.createElement("a");
        link.href = "#";
        link.className = "pp-listing-card__pagination-link";
        link.dataset.clientPageLink = "";
        link.dataset.pageNumber = String(part.page);
        link.setAttribute(
          "aria-label",
          this.formatTemplate(this.pageLabelTemplate, { page: part.page }),
        );
        link.textContent = String(part.page);
        item.append(link);
      }

      list.append(item);
    });

    list.append(
      makeArrow("next", this.clientPage + 1, this.clientPage < totalPages),
    );

    this.clientPagination.replaceChildren(list);
  }

  resetFilterableListState() {
    if (this.input instanceof HTMLInputElement) {
      this.input.value = "";
    }

    const filters = this.filterConfigs.reduce((nextFilters, config) => {
      nextFilters[config.name] = "all";
      return nextFilters;
    }, {});

    this.applyFilterableListState(filters);
    this.updateFilterableUrl(filters);
    this.filterConfigs.forEach((config) => this.closeFilterDetails(config));
  }

  getPagination() {
    return this.queryOptional(this.getOption("paginationSelector", ""));
  }

  getCards() {
    return Array.from(this.root.querySelectorAll(this.cardSelector));
  }

  cloneCards(cards) {
    return cards.map((card) => card.cloneNode(true));
  }

  renderCards(cards) {
    if (!(this.grid instanceof HTMLElement)) return;
    this.grid.replaceChildren(...this.cloneCards(cards));
  }

  getCurrentPage() {
    return this.normalizePageNumber(
      this.getPagination()?.dataset.currentPage || "1",
    );
  }

  getTotalPages() {
    return this.normalizePageNumber(this.getPagination()?.dataset.pages || "1");
  }

  cacheCurrentPage() {
    const currentPage = this.getCurrentPage();
    if (this.pageCache.has(currentPage)) return;
    this.pageCache.set(currentPage, this.cloneCards(this.getCards()));
  }

  restoreCurrentPageCards() {
    this.cacheCurrentPage();
    const currentCards = this.pageCache.get(this.getCurrentPage());
    if (currentCards) {
      this.renderCards(currentCards);
    }
  }

  getMatchingCards(cards, query) {
    return cards.filter((card) => {
      const haystack =
        `${card.dataset.searchText || ""} ${card.textContent || ""}`.toLowerCase();
      return !query || haystack.includes(query);
    });
  }

  buildCleanUrl(pageNumber) {
    const cleanUrl = new URL(window.location.href);
    this.removePaginationParams(cleanUrl);

    if (pageNumber > 1) {
      cleanUrl.searchParams.set("page", String(pageNumber));
    }

    return cleanUrl;
  }

  buildPaginationRequestUrl(pageNumber, requestHref) {
    const pagination = this.getPagination();
    const pageParam = pagination?.dataset.pageParam || "page";
    const requestUrl = requestHref
      ? new URL(requestHref, window.location.origin)
      : new URL(window.location.href);

    this.removePaginationParams(requestUrl);
    requestUrl.searchParams.set(pageParam, String(pageNumber));
    if (this.sectionId) {
      requestUrl.searchParams.set("section_id", this.sectionId);
    }

    return requestUrl;
  }

  async fetchPageCards(pageNumber) {
    if (this.pageCache.has(pageNumber)) {
      return this.pageCache.get(pageNumber);
    }

    const requestUrl = this.buildPaginationRequestUrl(pageNumber);
    try {
      const response = await fetch(requestUrl.toString(), {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      if (!response.ok) return [];

      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(
        html,
        "text/html",
      );
      const nextRoot =
        documentFragment.querySelector(this.rootSelector) ||
        documentFragment
          .getElementById(`shopify-section-${this.sectionId}`)
          ?.querySelector(this.rootSelector);
      const nextCards =
        nextRoot instanceof HTMLElement
          ? Array.from(nextRoot.querySelectorAll(this.cardSelector)).map(
              (card) => card.cloneNode(true),
            )
          : [];

      this.pageCache.set(pageNumber, nextCards);
      return nextCards;
    } catch (error) {
      return [];
    }
  }

  async getAllSearchCards() {
    this.cacheCurrentPage();

    const totalPages = this.getTotalPages();
    const pageNumbers = Array.from(
      { length: totalPages },
      (_item, index) => index + 1,
    );
    const pageCards = [];

    for (
      let index = 0;
      index < pageNumbers.length;
      index += this.searchFetchConcurrency
    ) {
      const pageBatch = pageNumbers.slice(
        index,
        index + this.searchFetchConcurrency,
      );
      const batchCards = await Promise.all(
        pageBatch.map((pageNumber) => this.fetchPageCards(pageNumber)),
      );
      pageCards.push(...batchCards);
    }

    return pageCards.flat();
  }

  async applyPaginatedSearch({ syncUrl = true } = {}) {
    const limitedInputValue = this.limitSearchInputValue(this.input.value);
    if (this.input.value !== limitedInputValue) {
      this.input.value = limitedInputValue;
    }

    const query = this.normalizeSearchValue(limitedInputValue);
    const normalizedQuery = query.toLowerCase();

    if (syncUrl) {
      this.updateUrl(query);
    }

    if (normalizedQuery) {
      const requestId = this.searchRequestId + 1;
      this.searchRequestId = requestId;
      this.root.classList.add("is-searching", "is-search-loading");
      this.root.setAttribute("aria-busy", "true");
      this.updateLoadingStatus();

      const allCards = await this.getAllSearchCards();
      if (requestId !== this.searchRequestId) return;

      const matchingCards = this.getMatchingCards(allCards, normalizedQuery);
      this.renderCards(matchingCards);
      this.root.classList.remove("is-search-loading");
      this.root.removeAttribute("aria-busy");
      this.updateStatus(matchingCards.length, normalizedQuery, allCards.length);
      this.updateEmptyState(matchingCards.length, normalizedQuery);
      return;
    }

    this.searchRequestId += 1;
    this.root.classList.remove("is-searching", "is-search-loading");
    this.root.removeAttribute("aria-busy");
    this.restoreCurrentPageCards();
    this.updateStatus(0, "", this.getCards().length);
    this.updateEmptyState(0, "");
  }

  scrollToListTop(target = this.root) {
    if (!(target instanceof HTMLElement)) return;

    const headerHeight =
      parseFloat(
        getComputedStyle(document.body).getPropertyValue("--header-height"),
      ) || 0;
    const targetTop = target.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: Math.max(targetTop - headerHeight, 0),
      behavior: "auto",
    });
  }

  async replaceSectionForPage(
    pageNumber,
    requestHref,
    historyMethod = "pushState",
    scrollToTop = true,
  ) {
    const requestUrl = this.buildPaginationRequestUrl(pageNumber, requestHref);
    this.root.setAttribute("aria-busy", "true");

    try {
      const response = await fetch(requestUrl.toString(), {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      if (!response.ok) {
        window.location.href = requestHref || requestUrl.toString();
        return;
      }

      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(
        html,
        "text/html",
      );
      const nextRoot =
        documentFragment.querySelector(this.rootSelector) ||
        documentFragment
          .getElementById(`shopify-section-${this.sectionId}`)
          ?.querySelector(this.rootSelector);

      if (!(nextRoot instanceof HTMLElement)) {
        window.location.href = requestHref || requestUrl.toString();
        return;
      }

      const cleanUrl = this.buildCleanUrl(pageNumber);
      window.history[historyMethod]({}, "", cleanUrl.toString());
      this.root.replaceWith(nextRoot);
      if (scrollToTop) {
        this.scrollToListTop(nextRoot);
      }
      initLegacyPrettyPortalListingSearch(nextRoot);
      this.clearPendingClass();
    } catch (error) {
      window.location.href = requestHref || requestUrl.toString();
    } finally {
      this.root.removeAttribute("aria-busy");
    }
  }

  syncCleanInitialPage(keepPending = false) {
    const pagination = this.getPagination();
    if (!(pagination instanceof HTMLElement)) {
      if (!keepPending) {
        this.clearPendingClass();
      }
      return false;
    }

    const pageParam = pagination.dataset.pageParam || "page";
    const url = new URL(window.location.href);
    const currentPage = this.getCurrentPage();
    const cleanPage = this.normalizePageNumber(
      url.searchParams.get("page") || "1",
    );
    const keyedPageValue = url.searchParams.get(pageParam);
    const keyedPage = keyedPageValue
      ? this.normalizePageNumber(keyedPageValue)
      : 0;

    if (pageParam !== "page" && keyedPage > 0) {
      window.history.replaceState(
        {},
        "",
        this.buildCleanUrl(currentPage).toString(),
      );
      if (!keepPending) {
        this.clearPendingClass();
      }
      return false;
    }

    if (pageParam !== "page" && cleanPage > 1 && cleanPage !== currentPage) {
      this.replaceSectionForPage(cleanPage, null, "replaceState", false);
      return true;
    }

    if (!keepPending) {
      this.clearPendingClass();
    }
    return false;
  }

  clearPendingClass() {
    if (this.pendingClass) {
      document.documentElement.classList.remove(this.pendingClass);
    }
  }

  handleRootClick(event) {
    if (!(event.target instanceof Element)) return;

    const loadMoreButton = event.target.closest("[data-client-load-more]");
    if (
      loadMoreButton instanceof HTMLElement &&
      this.root.contains(loadMoreButton)
    ) {
      event.preventDefault();
      const previousVisibleCount = this.getCards().filter(
        (card) => !card.hidden,
      ).length;
      this.clientPage += 1;
      this.applyFilterableListState(this.getActiveFilterValues(), {
        resetClientPage: false,
      }).then(() => this.animateRevealedCards(previousVisibleCount));
      return;
    }

    const clientPageLink = event.target.closest("[data-client-page-link]");
    if (
      clientPageLink instanceof HTMLElement &&
      this.root.contains(clientPageLink)
    ) {
      event.preventDefault();
      const pageNumber = this.normalizePageNumber(
        clientPageLink.dataset.pageNumber || "1",
      );
      if (pageNumber !== this.clientPage) {
        this.clientPage = pageNumber;
        this.updateClientPageUrl(pageNumber);
        this.applyFilterableListState(this.getActiveFilterValues(), {
          resetClientPage: false,
        });
        this.scrollToListTop();
      }
      return;
    }

    if (this.mode === "filterable-paginated-section") {
      const filterRemoveButton = event.target.closest("[data-filter-remove]");
      if (
        filterRemoveButton instanceof HTMLElement &&
        this.root.contains(filterRemoveButton)
      ) {
        event.preventDefault();
        const filterName = filterRemoveButton.dataset.filterRemove || "";
        const filterConfig = this.filterConfigs.find(
          (config) => config.name === filterName,
        );
        if (filterConfig) {
          const filters = {
            ...this.getActiveFilterValues(),
            [filterConfig.name]: "all",
          };
          this.applyFilterableListState(filters);
          this.updateFilterableUrl(filters);
          this.closeFilterDetails(filterConfig);
        }
        return;
      }

      const resetButton = event.target.closest("[data-filter-reset]");
      if (
        resetButton instanceof HTMLElement &&
        this.root.contains(resetButton)
      ) {
        event.preventDefault();
        this.resetFilterableListState();
        return;
      }

      const filterConfig = this.filterConfigs.find((config) => {
        const option = event.target.closest(config.interactiveSelector);
        return option instanceof HTMLElement && this.root.contains(option);
      });

      if (filterConfig) {
        const option = event.target.closest(filterConfig.interactiveSelector);
        if (option instanceof HTMLElement) {
          event.preventDefault();
          const currentFilters = this.getActiveFilterValues();
          const selectedValue = this.normalizeFilterValue(
            this.getFilterValue(option, filterConfig),
            filterConfig,
          );
          const currentValue = currentFilters[filterConfig.name] || "all";
          const nextValue =
            filterConfig.togglesOnRepeat &&
            selectedValue !== "all" &&
            selectedValue === currentValue
              ? "all"
              : selectedValue;
          const filters = { ...currentFilters, [filterConfig.name]: nextValue };

          this.applyFilterableListState(filters);
          this.updateFilterableUrl(filters);
          this.closeFilterDetails(filterConfig);
          return;
        }
      }
    }

    const paginationLink = event.target.closest("a[data-pagination-link]");
    if (
      paginationLink instanceof HTMLAnchorElement &&
      this.root.contains(paginationLink)
    ) {
      const pageNumber = this.normalizePageNumber(
        paginationLink.dataset.pageNumber || "1",
      );
      event.preventDefault();
      this.replaceSectionForPage(pageNumber, paginationLink.href);
    }
  }

  closeFilterDetails(config) {
    const details = config.detailsSelector
      ? this.root.querySelector(config.detailsSelector)
      : null;
    if (details instanceof HTMLDetailsElement) {
      details.open = false;
    }
  }

  closeOpenDetailsOnOutsideClick(event) {
    if (this.mode !== "filterable-paginated-section") return;

    this.filterConfigs.forEach((config) => {
      if (!config.detailsSelector) return;

      const details = this.root.querySelector(config.detailsSelector);
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;
      if (!(event.target instanceof Node) || details.contains(event.target))
        return;

      details.open = false;
    });
  }

  scheduleSearch() {
    window.clearTimeout(this.searchTimeout);
    this.searchTimeout = window.setTimeout(() => {
      if (this.mode === "filterable-paginated-section") {
        const filters = this.applySearchDrivenFilterRules(
          this.getActiveFilterValues(),
        );
        this.applyFilterableListState(filters);
        this.updateFilterableUrl(filters);
        return;
      }

      if (this.mode === "paginated-section") {
        this.applyPaginatedSearch();
        return;
      }

      this.applySearch();
    }, this.debounceDelay);
  }
}

class PrettyPortalListingSearchElement extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ppListingSearchInitialized === "true") return;

    this.dataset.ppListingSearchInitialized = "true";
    this.prettyPortalListingSearch = new PrettyPortalListingSearch(this);
    this.prettyPortalListingSearch.init();
  }

  disconnectedCallback() {
    this.prettyPortalListingSearch?.destroy();
    this.prettyPortalListingSearch = null;
    delete this.dataset.ppListingSearchInitialized;
  }
}

if (!customElements.get("pretty-portal-listing-search")) {
  customElements.define(
    "pretty-portal-listing-search",
    PrettyPortalListingSearchElement,
  );
}

const initLegacyPrettyPortalListingSearch = (scope = document) => {
  const roots =
    scope instanceof Element &&
    scope.matches("[data-pp-listing-search]:not(pretty-portal-listing-search)")
      ? [scope]
      : Array.from(
          scope.querySelectorAll(
            "[data-pp-listing-search]:not(pretty-portal-listing-search)",
          ),
        );

  roots.forEach((root) => {
    if (root.dataset.ppListingSearchInitialized === "true") return;
    root.dataset.ppListingSearchInitialized = "true";
    new PrettyPortalListingSearch(root).init();
  });
};

initLegacyPrettyPortalListingSearch();

document.addEventListener("shopify:section:load", (event) => {
  initLegacyPrettyPortalListingSearch(event.target);
});
